export function useTiktokPixel() {
  if (window.ttq) {
      // Clear the old instance if it exists
      delete window.ttq;
  }

  // Reinitialize TikTok Pixel
  (function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    const ttq = (w[t] = w[t] || []);
    ttq.methods = [
      'page', 'track', 'identify', 'instances', 'debug',
      'on', 'off', 'once', 'ready', 'alias', 'group',
      'enableCookie', 'disableCookie'
    ];
    ttq.setAndDefer = function (obj, method) {
      obj[method] = function () {
        obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    ttq.load = function (pixelId) {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${pixelId}&lib=${t}`;
      const f = d.getElementsByTagName('script')[0];
      f.parentNode.insertBefore(s, f);
    };
  })(window, document, 'ttq');
}